module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAATBAMAAACJlYuFAAAAAXNSR0IB2cksfwAAABVQTFRFAAAA////////////////////////SM9tBAAAAAd0Uk5TAAhoMIBQIIC+ygQAAABgSURBVHicTY6xFcAgCEShSJ+XFTS9OwjWFBnA/aeIoCJXcf7DA2AKExw9VHzGTDUAcjQAObpI1QNhy5e5I/ZaDfH6yJCsuKJ3Nyi61XxqWui2/K7geJa4wXzAQBIM+vQDWrwSu5QCkEsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/side-menu-reports.png
// module id = 955
// module chunks = 0